<template>
  <div class="contents">
    <div class="wrap">
      <section>
        <h2 class="page_title --view">예치금 등록</h2>
      </section>
      <section class="view">
        <div class="table_list">
          <table class="write">
            <colgroup>
              <col width="200">
              <col width="*">
            </colgroup>
            <tbody>
            <tr>
              <th><span>회원명</span></th>
              <td>
                <div class="form_inline">
                  <input type="text" class="form_control limit" placeholder="입력해주세요." v-model="regData.doctor_nm"
                         readonly>
                  <button class="btn btn_md btn_deepblue" @click="fn_click_clinicSearch">검색</button>
                </div>
              </td>
            </tr>
            <tr>
              <th><span>한의원명</span></th>
              <td>
                <div class="form_inline">
                  <input type="text" class="form_control limit" placeholder="입력해주세요." v-model="regData.clinic_nm"
                         readonly>
                </div>
              </td>
            </tr>
            <tr>
              <th><span>예치금</span></th>
              <td>
                <div class="form_inline">
                  <input
                      type="text"
                      class="form_control limit"
                      placeholder="입력해주세요."
                      :value="regData.deposit_amount"
                      @keydown="onlyPlusNumber"
                      @input="onNumberInput($event,'regData.deposit_amount')"
                  > <span> {{ amountKor }}</span>
                </div>
              </td>
            </tr>
            <tr>
              <th><span class="emp">사유 유형</span></th>
              <td>
                <div class="form_inline">
                  <div  class="form_radio" v-for="(item, index) in reasonCodeList" :key="index">
                    <input type="radio" :id="index" name="radio" :value="item.dtl_code" v-model="regData.tx_type">
                    <label :for="index">{{item.dtl_code_nm}}</label>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th><span>사유</span></th>
              <td>
                <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.reason">
              </td>
            </tr>
            </tbody>
          </table>
          <div class="bottom_box">
            <button class="btn btn_md btn_outline" @click="fn_move_page">목록</button>
            <div class="btn_box">
              <!-- button class="btn btn_md btn_gray">취소</button -->
              <button class="btn btn_md btn_darkblue" @click="fn_reg">저장</button>
            </div>
          </div>
        </div>
      </section>
    </div>
    <clinicDoctorSearch
        :title="'회원 검색'"
        :searchName="'회원명'"
        :searchData="regData.doctor_nm"
        :oneBtn="true"
        :btnLeft="'적용'"
        :btnRight="'닫기'"
        @callback="fn_callback"
    />
  </div>
</template>

<script>
import axios from 'axios'
import commonUtil from "@/mixin/commonUtil";
import clinicDoctorSearch from "@/modal/admin/clinicDoctorSearch.vue";

export default {
  name: 'UserDepositReg',
  mixins: [commonUtil],
  components: {clinicDoctorSearch},
  data() {
    return {
      regData: {
        clinic_doctor_id: "",
        doctor_nm: "",
        clinic_nm: "",
        deposit_amount: "0",
        tx_type: 'S',
        reason: ''
      },
      reasonCodeList: []
    }
  },
  computed: {
    amountKor() {
      return this.numberToKorean(this.regData.deposit_amount);
    }
  },
  async created() {
    let codeList = await this.getCode("GC00000019");
    this.reasonCodeList = codeList.filter(item => item.dtl_code != 'U' && item.dtl_code != 'E');  //사용과 만료는 제외
  },
  methods: {
    fn_reg() {

      //유효성 체크
      if (this.regData.reason_type != '') {
        if (this.regData.deposit_amount <= 0) {
          alert("예치금을 입력해주세요.");
          return;
        }
      } else {
        alert("사유를 선택해주세요.");
        return;
      }


      //console.log("@@@@ regData : %o",this.regData);

      axios.post("/api/admin/userMngt/createUserDeposit",
          this.regData
      ).then((res) => {
        console.log("@@@@ res : %o", res);
        alert("저장되었습니다");
        this.fn_move_page()
      })
          .catch((err) => console.log(err));


    },
    fn_move_page() {
      //this.$store.commit('commonStore/setSearchInfo', this.searchInfo);
      this.$router.push("/admin/userMngt/userDepositList");
    },
    fn_click_clinicSearch() {
      //약재 정보 모달 show
      this.$bvModal.show("clinicDoctorSearch");
    },
    fn_callback(medObject) {

      console.log("@@@@@@ medObject : %o", medObject);
      //약재 정보 콜백정보
      this.regData.clinic_doctor_id = medObject.clinic_doctor_id;
      this.regData.doctor_nm = medObject.doctor_nm;
      this.regData.clinic_nm = medObject.clinic_nm;
    },
    fn_reason_change() {
      if (this.regData.reason_coode !== 'O') {
        this.regData.reason = '';
      }
    }
  }
}
</script>